import { Translator } from 'Translator';
import React, { memo } from 'react';
import { translateCity, translateCountry } from 'utils/TranslationHelper';

const CSS = require('./TopSearchesTitle.less');

interface TopSearchesTitleProps {
  city?: string;
  country?: string;
  nrOfResults: number;
  titleParsed: string;
  titleKey: string;
}

function getTitle(
  nrOfResults: number,
  area?: string,
  topSearchesTitleText?: { translateKey: string; text: string },
) {
  if (topSearchesTitleText) {
    return {
      text: topSearchesTitleText.text.replace(
        '{nrOfResults}',
        String(nrOfResults),
      ),
      translateKey: topSearchesTitleText.translateKey,
    };
  }

  if (!area) {
    const key = 'SearchResults.topSearches.titleManyWithoutArea';
    return {
      translateKey: key,
      text: Translator.translate(
        key,
        { nrOfResults },
        true,
        'Top {nrOfResults} things to do',
      ),
    };
  }
  const key = 'SearchResults.topSearches.titleMany';
  return {
    translateKey: key,
    text: Translator.translate(
      key,
      { nrOfResults, city: area },
      true,
      'Top {nrOfResults} things to do in {city}',
    ),
  };
}

function TopSearchesTitle({
  city,
  country,
  nrOfResults,
  titleParsed,
  titleKey,
}: TopSearchesTitleProps) {
  const topSearchesTitleText = { text: titleParsed, translateKey: titleKey };
  const area = city
    ? translateCity(city, true)
    : country
    ? translateCountry(country, true)
    : null;
  const title = getTitle(nrOfResults, area, topSearchesTitleText);
  return (
    <div className={CSS.TopSearchesTitleContainer}>
      <h2
        data-translatekey={title.translateKey}
        className={CSS.TopSearchesTitle}
      >
        {title.text}
      </h2>
    </div>
  );
}

export default memo(TopSearchesTitle);
